import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import type { WorkerStatus } from '../types/billing';

export interface WorkerStatusChipProps {
  status: WorkerStatus;
}

function formatRelativeTime(iso: string | null): string {
  if (iso === null) return 'never';
  const seconds = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ago`;
}

const WorkerStatusChip: React.FC<WorkerStatusChipProps> = ({ status }) => {
  const tooltip =
    `Last activity ${formatRelativeTime(status.lastSeenAt)} · ` +
    `${status.queueDepth} in queue · ${status.inFlight} in flight`;

  if (status.state === 'OFFLINE') {
    return (
      <Tooltip title={tooltip} arrow>
        <Chip
          label="Extension offline"
          color="error"
          size="small"
          variant="filled"
          aria-label={tooltip}
        />
      </Tooltip>
    );
  }

  if (status.state === 'STUCK') {
    const waiting = status.queueDepth + status.inFlight;
    return (
      <Tooltip title={tooltip} arrow>
        <Chip
          label={`Extension may be stuck · ${waiting} waiting`}
          color="warning"
          size="small"
          variant="filled"
          aria-label={tooltip}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip} arrow>
      <Chip
        label="Extension active"
        color="success"
        size="small"
        variant="filled"
        aria-label={tooltip}
      />
    </Tooltip>
  );
};

export default WorkerStatusChip;
